import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateEvaluationSearch } from "./-search-params";

/**
 * Pathless layout route for hardware evaluation tests.
 * Groups: audio, digitizer, multitouch, biometrics, gyroscope
 */
export const Route = createFileRoute("/$locale/$partner/_evaluation")({
	validateSearch: validateEvaluationSearch,
	component: EvaluationLayout,
});

function EvaluationLayout() {
	return <Outlet />;
}
